export class NotificationToFrontNeededItemContactModel {
  ToContactID: string;
  enumLetterDeliveryToRoleID: string; // patient, doctor, other (patientContact)
}
